import DocumentsSubmittedByCandidate from './DocumentsSubmittedByCandidate.component';

export default DocumentsSubmittedByCandidate;